import React, { useState } from 'react';
import {
    Box,
    TextField,
    MenuItem,
    Button,
    Typography,
    InputLabel,
    Select,
    FormControl,
} from '@mui/material';
import DashboardLayout from '../Layout/DashboardLayout';
import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import '@mantine/tiptap/styles.css';
import CustomRichTextEditor from '../../extensions/RichTextEditor';
import { createArticle } from '../../models/Article'
import excuseApi from '../../api/excuseApi';
// ... các import giữ nguyên
import { Radio, RadioGroup, FormControlLabel } from '@mui/material';
const API_BASE = process.env.REACT_APP_API_URL;

const AddArticles = () => {
    const [categoryId, setCategoryId] = useState('');
    const [type, setType] = useState('text');
    const [timelineId, setTimelineId] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [thumbnail, setThumbnail] = useState(null);
    const [video, setVideo] = useState(null);
    const [videoLink, setVideoLink] = useState('');
    const [videoInputType, setVideoInputType] = useState('upload'); // upload | link
    const [content, setContent] = useState('');

    const editor = useEditor({
        extensions: [StarterKit],
        content: '',
        onUpdate: ({ editor }) => {
            setContent(editor.getHTML());
        },
    });
    const BASE_URL = process.env.REACT_APP_API_URL;

    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await excuseApi({
                endpoint: '/upload',
                method: 'POST',
                data: formData,
            });
            return response.url;
        } catch (error) {
            throw new Error('Không thể upload file');
        }
    };

    const uploadVideo = async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await excuseApi({
                endpoint: '/upload',
                method: 'POST',
                data: formData,
            });
            return `${BASE_URL}${response.url}`;
        } catch (error) {
            throw new Error('Không thể upload file');
        }
    };

    const processContentImages = async (html) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        const mediaElements = div.querySelectorAll('img, video source');

        for (let el of mediaElements) {
            const src = el.getAttribute('src');
            if (src && src.startsWith('data:')) {
                try {
                    const response = await fetch(src);
                    const blob = await response.blob();
                    const file = new File([blob], 'upload', { type: blob.type });

                    const base64 = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = reject;
                        reader.readAsDataURL(file);
                    });

                    const isImage = file.type.startsWith('image/');
                    const bodyKey = isImage ? 'image' : 'video';

                    const res = await fetch(`${API_BASE}/upload-article-image`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            [bodyKey]: base64,
                            article_id: null
                        }),
                    });

                    const data = await res.json();
                    if (data.url) {
                        el.setAttribute('src', data.url);
                    }
                } catch (err) {
                    throw err;
                }
            }
        }
        return div.innerHTML;
    };

    const handleSubmit = async () => {
        if (!categoryId) {
            alert('Vui lòng chọn chuyên mục');
            return;
        }

        try {
            const thumbnailUrl = await uploadFile(thumbnail);
            let finalContent = content;

            if (type === 'video') {
                if (videoInputType === 'upload') {
                    if (!video) {
                        alert('Vui lòng chọn video để tải lên');
                        return;
                    }

                    const videoUrl = await uploadVideo(video);

                    // Render video upload dạng <video>
                    finalContent = `
    <div class="video-wrapper" style="position: relative; width: 100%; padding-bottom: 56.25%; height: 0;">
      <video controls style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
        <source src="${videoUrl}" type="${video?.type || 'video/mp4'}" />
        Trình duyệt của bạn không hỗ trợ video.
      </video>
    </div>
    `;
                }

                else if (videoInputType === 'link') {
                    if (!videoLink.trim()) {
                        alert('Vui lòng nhập link video');
                        return;
                    }

                    const link = videoLink.trim();

                    // Kiểm tra nếu là link YouTube
                    const youtubeMatch = link.match(
                        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                    );

                    if (youtubeMatch) {
                        const videoId = youtubeMatch[1];
                        finalContent = `
    <div class="video-wrapper" style="position: relative; width: 100%; padding-bottom: 56.25%; height: 0;">
      <iframe 
        src="https://www.youtube.com/embed/${videoId}" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
      </iframe>
    </div>
    `;
                    } else {
                        // Link mp4 trực tiếp
                        finalContent = `
    <div class="video-wrapper" style="position: relative; width: 100%; padding-bottom: 56.25%; height: 0;">
      <video controls style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
        <source src="${link}" type="video/mp4" />
        Trình duyệt của bạn không hỗ trợ video.
      </video>
    </div>
    `;
                    }
                }
            } else {
                finalContent = await processContentImages(content);
            }

            const formData = {
                category_id: categoryId,
                type,
                title,
                timeline_id: timelineId,
                thumbnail: thumbnailUrl,
                description,
                content: finalContent,
            };

            const res = await createArticle(formData);
            await fetch(`${BASE_URL}/move-tmp-to-article/${res.article_id}`, { method: 'POST' });

            alert('Tạo bài viết thành công');
        } catch (err) {
            alert('Lỗi: ' + err.message);
        }
    };


    return (
        <DashboardLayout>
            <Box sx={{ marginLeft: '260px', padding: 3, maxWidth: 800 }}>
                <Typography variant="h4" gutterBottom>Thêm bài viết</Typography>

                {/* Chọn chuyên mục */}
                <FormControl fullWidth margin="normal">
                    <InputLabel>Chọn chuyên mục</InputLabel>
                    <Select
                        value={categoryId}
                        onChange={(e) => {
                            setCategoryId(e.target.value);
                            setType('text');
                            setTitle('');
                            setTimelineId('');
                            setThumbnail(null);
                            setVideo(null);
                            setVideoLink('');
                            setDescription('');
                            setContent('');
                        }}
                    >
                        <MenuItem value="1">Chiến ký</MenuItem>
                        <MenuItem value="2">Lược sử</MenuItem>
                    </Select>
                </FormControl>

                {categoryId && (
                    <>
                        {categoryId === '1' && (
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Loại bài viết</InputLabel>
                                <Select
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                >
                                    <MenuItem value="text">Bài biên tập</MenuItem>
                                    <MenuItem value="video">Video</MenuItem>
                                </Select>
                            </FormControl>
                        )}

                        <TextField
                            fullWidth
                            label="Tiêu đề bài viết"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            margin="normal"
                        />

                        <FormControl fullWidth margin="normal">
                            <InputLabel>Mốc thời gian</InputLabel>
                            <Select
                                value={timelineId}
                                onChange={(e) => setTimelineId(e.target.value)}
                            >
                                <MenuItem value={1}>KCCP</MenuItem>
                                <MenuItem value={2}>KCCM</MenuItem>
                                <MenuItem value={3}>1975</MenuItem>
                            </Select>
                        </FormControl>

                        <Box my={2}>
                            <Typography>Thumbnail (jpg, png)</Typography>
                            <input
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={(e) => setThumbnail(e.target.files[0])}
                            />
                        </Box>

                        <TextField
                            fullWidth
                            label="Mô tả ngắn (tối đa 100 chữ)"
                            value={description}
                            onChange={(e) => {
                                const words = e.target.value.trim().split(/\s+/);
                                if (words.length <= 100) setDescription(e.target.value);
                            }}
                            helperText={`${description.trim().split(/\s+/).length}/100 chữ`}
                            margin="normal"
                            multiline
                            rows={3}
                        />

                        {type === 'text' && editor && (
                            <Box my={2}>
                                <Typography variant="h6">Nội dung bài viết</Typography>
                                <CustomRichTextEditor value={content} onChange={setContent} />
                            </Box>
                        )}

                        {type === 'video' && (
                            <Box my={2}>
                                <Typography>Chọn cách thêm video</Typography>
                                <RadioGroup
                                    row
                                    value={videoInputType}
                                    onChange={(e) => setVideoInputType(e.target.value)}
                                >
                                    <FormControlLabel value="upload" control={<Radio />} label="Tải video lên" />
                                    <FormControlLabel value="link" control={<Radio />} label="Chèn link video" />
                                </RadioGroup>

                                {videoInputType === 'upload' && (
                                    <Box mt={2}>
                                        <input
                                            type="file"
                                            accept="video/*"
                                            onChange={(e) => setVideo(e.target.files[0])}
                                        />
                                    </Box>
                                )}

                                {videoInputType === 'link' && (
                                    <TextField
                                        fullWidth
                                        label="Nhập link video"
                                        value={videoLink}
                                        onChange={(e) => setVideoLink(e.target.value)}
                                        margin="normal"
                                    />
                                )}
                            </Box>
                        )}

                        <Button variant="contained" onClick={handleSubmit} sx={{ mt: 3 }}>
                            Đăng bài
                        </Button>
                    </>
                )}
            </Box>
        </DashboardLayout>
    );
};

export default AddArticles;
